import React, { useState } from "react";

const CoolDownButton = ({
  remainingSeconds = 0,
  onClicking,
  text,
  isLoading,
  disabled,
  loadingText = "Loading...",
  waitText = "Please wait...",
  type = "button",
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const isCooldown = disabled && !isLoading;

  return (
    <button
      onClick={onClicking}
      disabled={disabled || isLoading}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      type={type}
      style={{
        background: isCooldown
        ? "rgba(15,23,42,0.46)"
        : "linear-gradient(110deg, #8fd3ff 0%, #d9f99d 48%, #fed7aa 100%)",
        color: isCooldown ? "#e2e8f0" : "#075985",
        padding: "0.95rem 1rem",
        border: isCooldown ? "1px solid rgba(148,163,184,0.2)" : "1px solid rgba(255,255,255,0.32)",
        borderRadius: "14px",
        cursor: isCooldown ? null : "pointer",
        marginTop: "0",
        width: "100%",
        fontWeight: "bold",
        fontSize: "0.95rem",
        boxShadow: isCooldown ? "none" : "0 16px 42px rgba(45,212,191,0.18)",
        filter: isHovered && !isCooldown ? "brightness(1.1)" : "none",
        transition: "opacity 0.3s ease, transform 0.2s ease, filter 0.2s ease",
        transform: isHovered && !isCooldown ? "translateY(-1px)" : "none",
      }}
    >
      {isLoading ? loadingText : (isCooldown ? `${waitText} (${remainingSeconds})` : text)}
    </button>
  );
};

export default CoolDownButton;
